import axiosClient from "../axios-client";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction"


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================

export const homeVideoList = async () => {
    return axiosClient
        .get("/home-videos/list")
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Video list not found", "error");
            throw error;
        });
};


export const getYoutubeThumbnail = async (video_id) => {
    const apiUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/v1/home-videos/youtube-thumbnail/${video_id}`;
    const response = await fetch(apiUrl);
    return response
};


// ===============================================================================
// =================================== POST API ==================================
// ===============================================================================

export const uploadVideo = async (dispatch, data) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .post("/home-videos/upload", data)
        .then((res) => {
            toastMessage("Video saved successfully.", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Failed to save the video. Please try again later.", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};



// ===============================================================================
// =================================== PUT API ===================================
// ===============================================================================

export const updateVideoDetails = async (dispatch, data, id) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .put(`/home-videos/update/${id}`, data)
        .then((res) => {
            toastMessage("Video details updated successfully.", "success")
            return res
        })
        .catch((error) => {
            toastMessage("Failed to update the video. Please try again later.", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const updateVideoOrder = async (dispatch, data) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .put(`/home-videos/update-order`, data)
        .then((res) => {
            toastMessage("Video order updated successfully.", "success")
            return res
        })
        .catch((error) => {
            toastMessage("Failed to update the video order. Please try again later.", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


// ===============================================================================
// ================================== DELETE API =================================
// ===============================================================================

export const deleteVideo = async (dispatch, id) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .delete(`/home-videos/delete/${id}`)
        .then((res) => {
            toastMessage("Video deleted successfully.", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Failed to delete the video. Please try again later.", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};